<script setup>
import { defineProps } from "vue";
import {
  svgProps,
  useSVGAccessibility,
} from "@/composables/useSVGAccessibility";

const props = defineProps(svgProps);

const { titleId, computedRole, ariaAttributes } = useSVGAccessibility(props);
</script>

<template>
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    :width="props.size"
    :height="props.size"
    viewBox="0 -960 960 960"
    :fill="props.fill"
    :stroke="props.stroke"
    :stroke-width="props.strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="computedRole"
    v-bind="ariaAttributes"
  >
    <template v-if="props.title">
      <title :id="titleId">{{ props.title }}</title>
    </template>
    <path
      d="M330-250h300v-60H330v60Zm0-160h300v-60H330v60Zm-77.69 310Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-620v-180H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-620H540ZM240-800v180-180V-160v-640Z"
    />
  </svg>
</template>
